import { render, staticRenderFns } from "./administrar.view.vue?vue&type=template&id=66894b71&"
import script from "./administrar.view.vue?vue&type=script&lang=js&"
export * from "./administrar.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports